/**
 * Phone number utilities for the auth flow.
 */

const INDIA_CODE = '+91';

/**
 * Converts whatever the user typed in the PhoneField into a full E.164 string.
 *
 * Rules:
 *  - Already starts with '+' → assume full E.164, strip spaces and return.
 *  - Starts with '0' → Indian convention; strip leading 0, prepend +91.
 *  - Otherwise → bare 10-digit Indian number; prepend +91.
 *
 * @example
 *   normalizePhone('9876543210')  → '+919876543210'
 *   normalizePhone('09876543210') → '+919876543210'
 *   normalizePhone('+919876543210') → '+919876543210'
 *   normalizePhone('+44 7700 900123') → '+447700900123'
 */
export function normalizePhone(value: string): string {
  const clean = value.replace(/\s/g, '');
  if (clean.startsWith('+')) return clean;
  if (clean.startsWith('0')) return `${INDIA_CODE}${clean.slice(1)}`;
  return `${INDIA_CODE}${clean}`;
}

/**
 * Masks an E.164 phone number for display in confirmations.
 * '+919876543210' → '+91 ••••• 43210'
 */
export function maskPhone(e164: string): string {
  if (e164.length < 5) return e164;
  const prefix = e164.slice(0, 3);   // +91
  const last5  = e164.slice(-5);
  return `${prefix} ••••• ${last5}`;
}

/**
 * Formats seconds as MM:SS for the OTP resend countdown.
 * 90 → '01:30'
 */
export function formatCountdown(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
